import { React, useState, useContext, useEffect } from 'react'
import axios from 'axios';

import { getIST } from '../bureauUtils';

import safetyIcon from '../../../Images/bureauImages/safetyIcon.png'
import backArrow from '../../../Images/bureauImages/backArrow.png'

import { BureauContext } from '../../Pages/HelloTradePage';
import { gatrack } from "../../../utils"

function OTPComponent() {

    const { displayPage, setDisplayPage, otpScreen , setPhoneError, setUserInfo, userInfo} = useContext(BureauContext);

    const goBack = () => {
        setDisplayPage(1)
    }

    const fetchBureau = async(payloadInfo) =>{
        const host = window.location.hostname;
        const url = host === 'www.hellotrade.com'
            ? 'https://www.hellotrade.com/api/v1/postConsent'
            : 'https://dev.hellotrade.com/api/v1/postConsent';

        

        const formData = new FormData();
        formData.append("data", JSON.stringify(payloadInfo));

        try {

            const response = await axios({
                method: 'post',
                url: url,
                data: formData,
                timeout: 5000
            });

            const data_obj = response.data;
            console.log("Data recieved from final write API: ", data_obj);

        } catch (error) {
            console.error('Error in writing consent and bureau \:', error);
        }
    }

    const handleIframeMessage = (event) => {
        const host = window.location.hostname;
        const finboxUrl = host == 'www.hellotrade.com'
            ? 'https://bureauconnectweb.finbox.in'
            : 'https://bureauconnectweb-uat.finbox.in';

        if (event.origin === finboxUrl) {
            //console.log('API Response from iframe:', event);
            if(event.data){
                if(event.data.status){
                    let stat = event.data.status.toLowerCase()
                if(stat == "success"){
                    const currentIST = getIST();
                    setUserInfo((prevInfo) => {
                        const updatedInfo = { ...prevInfo, consentTime: currentIST };
                        //console.log("User Info after updating consentTime:", updatedInfo);
                        fetchBureau(updatedInfo);
                        return updatedInfo;
                    });
                    gatrack("HT Journey", "Consent Provided", "SDK", userInfo.glid)
                    setDisplayPage(3);
                    
                }
                else if(stat == "error") {
                    setPhoneError(true);
                    setDisplayPage(1);
                } 
                else if(stat = "exit"){
                    setDisplayPage(1);
                }
               }
            }
        }
    };

    

    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);

        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

    return (
        <>
            <div id='pi-parent'>
                <div className='pi otp-screen'>
                    <div className='pi-header'>
                        {/* <span id='back-arrow-parent' onClick={goBack}><img src={backArrow} style={{ width: '16px' }} /></span> */}
                        <div id='header-text'>Consent for Bureau Verification</div>
                        <div className='no-affect'>(This doesn't affect your bureau score)</div>
                    </div>

                    <div className="progress-bar">
                        <div className="progress-indicator" style={{width:'40%'}}></div>
                    </div>

                    <div style={{ height: '606px' }}>
                        <iframe
                            src={otpScreen}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            title="External Content"
                            allowFullScreen
                        />
                    </div>

                    <div >

                        <div className='safety'>
                            <img src={safetyIcon} />
                            <div id='safety-text'>Your data is 100% safe & secure</div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default OTPComponent